import {createStore, applyMiddleware} from 'redux';
import promiseMiddleware from 'redux-promise-middleware';
import {createLogger} from 'redux-logger';
import ReduxThunk from 'redux-thunk';
import {composeWithDevTools} from 'redux-devtools-extension';

const middlewares = [ReduxThunk, promiseMiddleware()];
if (__DEV__) {
  const logger = createLogger({
    collapsed: true,
  });

  middlewares.push(logger);
}

export default (reducers, data = {}) => (
  createStore(reducers, data, composeWithDevTools(applyMiddleware(...middlewares)))
);
